import {
    useCallback,
} from 'react'

import FormWithControls from 'app/shared-components/FormWithControls'
import {
    ActionComponentCreateProps,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'
import requests from 'app/requests/User.requests'
import getUserFormFields from '../UserForm.fields'

const UserCreate = ({
    onSuccess,
}: ActionComponentCreateProps) => {
    const modifyDataBeforeSend = useCallback((update) => {
        return {
            ...update,
            hint: undefined,
        }
    }, [])

    return (
        <FormWithControls
            onSuccess={onSuccess}
            modifyDataBeforeSend={modifyDataBeforeSend}
            name="Users"
            fields={getUserFormFields(true)}
            requestParams={requests.create()}
        />
    )
}

export default UserCreate
